import React from "react";

export default function FemcareLogo({ className = "w-9 h-9" }) {
    return (
        <img
            src="/femcare-logo.png"
            alt="Femcare.life logo"
            className={`${className} object-contain`}
            draggable={false}
        />
    );
}
